import { Card, CardContent, CardContentProps, Typography, TypographyProps } from '@mui/material';
import { CenteredColumn } from 'src/Common/Components/Stacks';

export const fadeTimeout = 2000;
export const countUpTime = 1500;
export const saturation = 400;
export const chartHeight = 82;
export const chartWidth = 82;
export const chartInnerRadius = 30;
export const chartOuterRadius = 41;

export const DeviceIntegrationCard = ({
  title,
  caption,
  children,
}: {
  title?: string;
  caption?: TypographyProps['children'];
  children: CardContentProps['children'];
}): React.JSX.Element => (
  <Card
    sx={{
      boxShadow: 'none',
      border: 1,
      borderRadius: 4,
      borderColor: (theme) => theme.palette.text.secondary,
    }}
  >
    <CardContent>
      <CenteredColumn width={'100%'}>
        {title && (
          <Typography
            gutterBottom
            color={'textPirmary'}
            sx={{
              fontSize: 20,
              fontWeight: 700,
              textAlign: 'center',
              userSelect: 'none',
            }}
          >
            {title}
          </Typography>
        )}
        {children}
        {caption && (
          <Typography
            color={'textPrimary'}
            sx={{
              userSelect: 'none',
              fontSize: 12,
              textAlign: 'center',
            }}
          >
            {caption}
          </Typography>
        )}
      </CenteredColumn>
    </CardContent>
  </Card>
);
